import { ForTeamsLogoBl } from "../../../../assets/img/logos/ForTeamsLogoBl.jsx"
import { ForTeamsLogoWh } from "../../../../assets/img/logos/ForTeamsLogoWh.jsx"
import { ForTeamsLogoPh } from "../../../../assets/img/logos/ForTeamsLogoPh.jsx"

import ForTeamsLogoColor from "../../../../enums/ForTeamsLogoColor";

function ForTeamsLogo(props) {
    const logo = getLogo(props);
    return logo;
}

const getLogo = (props) => {
    switch (props.color) {
        case ForTeamsLogoColor.black:
            return (
                <ForTeamsLogoBl className={props.className} />
            );
        case ForTeamsLogoColor.white:
            return (
                <ForTeamsLogoWh className={props.className} />
            );
        case ForTeamsLogoColor.purpleHaze:
            return (
                <ForTeamsLogoPh className={props.className} />
            );
        default: return <ForTeamsLogoBl className={props.className} />;
    }
}
export default ForTeamsLogo;